import React from 'react';

import { Typography } from '@crossnokaye/ux-common';

import { Stack } from '@/ux-common/components/stack/stack';

/**
 * Condenser-specific instruction content to be passed to SequencerInstructions.
 */
export const CondenserSequencerInstructionsContent: React.FC = () => {
  return (
    <Stack className="select-text mt-2">
      <Stack className="stack-thin">
        <Typography variant="h3">Overview</Typography>
        <Typography variant="body">
          <Stack className="stack-thin">
            The condenser sequencer grid is used to configure the condenser system.
            <ul className="list-disc list-inside">
              <li>The columns in the grid indicate the Sequence Order.</li>
              <li>The rows in the grid display each condenser component in the system.</li>
              <li>
                The cells in the grid display the <b>On</b> and <b>Off</b> state for each condenser
                component during each stage of the Sequence Order.
              </li>
            </ul>
            Metrics and Settings for the sequencer are available above in this sequencer detail
            screen.
          </Stack>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3">Check Before Saving</Typography>
        <Typography variant="body">
          <Stack className="stack-thin">
            Before saving changes, review your sequence for the following and make any necessary
            changes to remove or alter them from the sequencer:
            <ul className="list-disc list-inside">
              <li>Empty stage = no equipment operating</li>
              <li>Duplicate stages = longer time to stage up and down</li>
            </ul>
          </Stack>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3"> How to Change the Condenser Equipment State </Typography>
        <Typography variant="body">
          <ol className="list-decimal list-inside">
            <li>
              Click a cell in the grid to toggle between compressor states (<b>On</b> or <b>Off</b>)
            </li>
            <li>
              Click <b>Save</b> at the bottom of the detail screen to preview your changes along
              with any other changes on the detail screen.
            </li>
            <li>
              Click <b>Save</b> in the preview screen to apply your changes.
            </li>
          </ol>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3">
          How to Add or remove Condenser Equipment from Sequencer
        </Typography>
        <Typography variant="body">
          In the left column of the sequencer:
          <ol className="list-decimal list-inside">
            <li>
              Click the <b>X</b> to disable the desired condenser from the sequencer.
            </li>
            <li>
              Click the <b>+</b> to enable the desired condenser in the sequencer.
            </li>
          </ol>
        </Typography>
      </Stack>
    </Stack>
  );
};
